import { render, staticRenderFns } from "./FileUploadHistory.vue?vue&type=template&id=1a39639e&scoped=true&"
import script from "./FileUploadHistory.vue?vue&type=script&lang=js&"
export * from "./FileUploadHistory.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadHistory.vue?vue&type=style&index=0&id=1a39639e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a39639e",
  null
  
)

export default component.exports